import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/product-catalog/components/ProductCatalog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
